var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 809 674",
    width: 809,
    height: 674,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 1000,
    height: 1000,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAPoAQMAAAB3bUanAAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAJFJREFUeJztwTEBAAAAwqD1T20KP6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL4G7D8AAfgxlyEAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb}.b{fill:#e6e6e6}.c{fill:#f0f0f0}.d{fill:#f5f5f5}.e{fill:#fff}.f{fill:#fafafa}.g{fill:#407bff}.h{opacity:.9;fill:#fff}.i{fill:#ff8b7b}.j{opacity:.2}.k{fill:#263238}.l{opacity:.6}.m{opacity:.3}.n{fill:#ea6900}.o{fill:#ff5652}.p{fill:#cd2c22}.q{opacity:.1}.r{opacity:.4;fill:#cd2c22}.s{fill:#b55b52}.t{fill:#a02724}.u{fill:#1c6f4b}.v{opacity:.3;fill:#156341}")), /*#__PURE__*/React.createElement("use", {
    style: {
      display: "none"
    },
    href: "#img1",
    x: -87,
    y: -191
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m913 574.3h-1000v-0.5h1000z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m746.6 606h66.2v0.5h-66.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m558.1 611.4h17.3v0.5h-17.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m706.2 587.4h38.4v0.5h-38.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m17.9 590.8h86.4v0.5h-86.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m122.1 590.8h12.7v0.5h-12.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m175.9 599.2h187.4v0.5h-187.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m387 484.6h-386.2c-6.3 0-11.4-5.1-11.4-11.4v-542.9c0-6.3 5.1-11.4 11.4-11.4h386.2c6.3 0 11.4 5.1 11.4 11.4v542.9c0 6.3-5.1 11.4-11.4 11.4zm-386.2-565.2c-6 0-10.9 4.9-10.9 10.9v542.9c0 6 4.9 10.9 10.9 10.9h386.2c6 0 10.9-4.9 10.9-10.9v-542.9c0-6-4.9-10.9-10.9-10.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m819.6 484.6h-386.2c-6.3 0-11.4-5.1-11.4-11.4v-542.9c0-6.3 5.1-11.4 11.4-11.4h386.2c6.3 0 11.4 5.1 11.4 11.4v542.9c0 6.3-5.1 11.4-11.4 11.4zm-386.2-565.2c-6 0-10.9 4.9-10.9 10.9v542.9c0 6 4.9 10.9 10.9 10.9h386.2c6 0 10.9-4.9 10.9-10.9v-542.9c0-6-4.9-10.9-10.9-10.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m659.3 157.2h-28.3v-88.2h28.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m736.1 157.2h-94l-14.2-103.2h94z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m746.3 157.2h-97.1l-14.2-103.2h97.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m656.2 149.1l-11.9-87h80.8l12 87z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m672.2 122.8l-4.5-32.7c-0.5-3.6 2.3-6.9 6-6.9h29.4c3 0 5.6 2.2 6 5.3l4.5 32.6c0.5 3.7-2.3 6.9-6 6.9h-29.4c-3 0-5.6-2.2-6-5.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m482.9 233.7h-423.6v-261.3h423.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m493.8 233.7h-429.4v-261.3h429.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m482.9 233.7h-423.6v20.2h423.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m511.9 233.7h-429.4v20.2h429.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m79.6 218.4v-230.8h398.9v230.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m108.9 218.4l89.4-230.8h42.2l-89.4 230.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m160.2 218.4l89.4-230.8h16.5l-89.5 230.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m316.6 218.4l89.5-230.8h16.4l-89.4 230.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m476.6 218.4v-230.8h1.9v230.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m804 573.8h-89.7v-416.6h89.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m795 573.8h9v-25.7h-18.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m646.9 573.8h-89.7v-416.6h89.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m804 558.1h-165v-400.9h165z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m648 573.8h-9v-25.7h18.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m797 353.7h-151v-189.1h151z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m737.8 179.3h-32.7c-14.2 0-27.7-5.8-37.5-16.2h107.8c-9.8 10.4-23.3 16.2-37.6 16.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m797 550.4h-151v-189.1h151z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m737.8 376h-32.7c-14.2 0-27.7-5.8-37.5-16.1h107.8c-9.8 10.3-23.3 16.1-37.6 16.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m172 288.8h149.2l21.7 88.1h-149.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m193.6 376.9l0.6 4.9h149.3l-0.6-4.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m176.6 288.8h149.2l21.7 88.1h-149.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m201.4 372.9l-19.7-80.1h141l19.6 80.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m237.1 376.9l0.6 4.9h164.4l-0.6-4.9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m439.6 573.8h-17.9v-192h17.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m445.2 573.8h-12.4v-192h12.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m218.6 403.8h230.5v-22h-230.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m210.6 573.8h-17.8v-170h17.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m216.3 573.8h-12.4v-170h12.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m97.5 573.8h-17.9v-170h17.9z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m103.1 573.8h-12.4v-170h12.4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m326.4 573.8h-17.9v-170h17.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m332 573.8h-12.4v-170h12.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m218.6 403.8h-139v-22h139z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m497.7 573.8h-4.4l-12.4-61.3-2.2-10.7-13.6-66.8h-52l-28.1 138.8h-4.4l28.7-141.4c0.2-1 1.1-1.7 2.1-1.7h55.5c1 0 1.9 0.7 2.1 1.7l11.9 58.7 2.2 10.7z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m581.2 573.8h-4.4l-28.2-138.8h-52l-13.5 66.8-2.2 10.7-12.5 61.3h-4.3l14.6-72 2.2-10.7 11.9-58.7c0.2-1 1.1-1.7 2.1-1.7h55.5c1 0 1.9 0.7 2.1 1.7z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m453 432.9h95.5c18.3 0 28.4-12.4 33.6-32.9l2.5-11.7c2.1-9.6-1.5-19.7-9.6-25.3-3.9-2.7-8.7-4.3-13.8-4.3h-59.9c-12.4 0-15.7 3-24.3 21.7-8.5 18.7-24 52.5-24 52.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m411.6 414.5h93.5v18.4h-101.8c-2.7 0-4.8-2.2-4.8-4.8v-0.5c0-7.2 5.9-13.1 13.1-13.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m482.8 194.1c-114.2-77.3-287.2-323.7-420.2-109.2-95.5 154.1 173.4 313.4 287.4 363.3 145.8 63.8 406.6 40.1 442.6-155.2 14.5-78.2-22.4-109.5-92.6-95.2-82.5 16.7-133.1 53.3-217.2-3.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m482.8 194.1c-114.2-77.3-287.2-323.7-420.2-109.2-95.5 154.1 173.4 313.4 287.4 363.3 145.8 63.8 406.6 40.1 442.6-155.2 14.5-78.2-22.4-109.5-92.6-95.2-82.5 16.7-133.1 53.3-217.2-3.7z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m800.8 641.5c0 12.5-173.6 22.6-387.8 22.6-214.2 0-387.8-10.1-387.8-22.6 0-12.5 173.6-22.7 387.8-22.7 214.2 0 387.8 10.2 387.8 22.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m319.1 577.5l-12.8 8.2-23.2-26.9 12.8-8.3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m295.9 550.5l-12.8 8.3 11.9 13.9 12.8-8.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m221.2 621.5l-14.7 1.4-15.3-35 14.7-1.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m191.2 588l7.9 18h15.4l-8.6-19.5z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m109.5 149c-7.4 0.7-7.6-11.9-20.6-6-16.6 7.6-11 19.2-23.9 18.7-12.9-0.5-21.5 9.6-18.6 17.1 2.9 7.5 7.3 14.6-1.8 17.6-9.1 3.1-15.3 5.7-14 13.3 1.3 7.5 7.8 10.6-3.1 15.4-10.9 4.8-9.8 25.7 0.9 25.7 10.6 0 0.4 10.4 10 20.9 9.5 10.6 24.1 12.1 30.1 6.8 6.1-5.3 12.8-9.5 24.2-1.5 11.4 8 30.7 10 29.9-2.7-0.9-12.6-12-21-1.6-27.6 10.5-6.6 24.1-9.8 19.8-22.7-2.7-8-10.9-14.9-4.3-20.9 10.7-9.7 10.8-31.7-2.3-37.3-7.7-3.2-0.3-19-24.7-16.8z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m95.2 247.8c-0.3 6-1.1 11.4-2 17q-1.4 8.4-3.6 16.6c-1.4 5.5-3.2 11-5.4 16.3q-1.7 4-3.7 8-1 2-2.1 3.9c-0.3 0.6-0.7 1.3-1.1 1.9l-0.6 1c-0.3 0.5-0.8 1.2-1.3 1.7-1 1.2-2.5 2.3-4 3-1.5 0.7-2.9 1-4.3 1.1-2.6 0.2-4.7-0.4-6.5-0.9-3.5-1.2-6.2-2.7-8.8-4.3-5-3.3-9.4-6.9-13.6-10.6-8.3-7.6-15.9-15.5-23-24.1l5.7-5.3c3.9 3.5 8 7.1 12.1 10.5 4.1 3.4 8.3 6.8 12.6 9.9 4.2 3.1 8.5 6.2 12.8 8.4 2.1 1.2 4.3 2.1 6 2.5 0.8 0.2 1.5 0.2 1.5 0.1q0.1 0-0.4 0.1c-0.2 0.1-0.5 0.4-0.7 0.5q-0.1 0.1-0.1 0.1c0 0-0.1 0.2 0 0l0.4-0.8c0.3-0.5 0.6-1 0.9-1.6q0.8-1.6 1.6-3.4 1.5-3.4 2.8-7c1.7-4.8 3.1-9.7 4.3-14.8 1.2-5 2.2-10.2 3-15.3 0.9-5.1 1.5-10.5 2-15.4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m106.8 249.7c-0.8 4.9-4.8 14-8 20.8-2.4 4.9-4.3 8.6-4.3 8.6l-2.8-1.2-23.2-10.3c1.8-12.5 4.6-26.1 18.4-32.2 8.7-3.8 21.4 5.7 19.9 14.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m106.8 249.7c-0.8 4.9-4.8 14-8 20.8-2.4 4.9-4.3 8.6-4.3 8.6l-2.8-1.2-23.2-10.3c1.8-12.5 4.6-26.1 18.4-32.2 8.7-3.8 21.4 5.7 19.9 14.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m98.8 270.5c-2.4 4.9-4.3 8.6-4.3 8.6l-2.8-1.2c0.4-4.9 1.4-12.7 4-16.2 1.7 2.5 2.6 5.6 3.1 8.8z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m21.7 277.6l1.9-13.5-15.1 5c0 0 2.4 8.1 7.8 11.5z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m16.7 252.6l-10.5 5.8 2.3 10.7 15.1-5z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m301.5 581.7l13.9-10c0.5-0.3 1.2-0.3 1.6 0.2l9.5 9.8c1 1.1 0.8 2.8-0.4 3.7-4.9 3.4-7.4 4.7-13.6 9.1-3.7 2.7-11.6 9.2-16.8 13-5.1 3.6-9.2-1.2-7.4-3.3 8.2-9 10.4-15.2 11.7-20.2 0.3-1 0.8-1.8 1.5-2.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m204.6 618.4h18c0.7 0 1.3 0.5 1.5 1.1l3.9 14.3c0.4 1.5-0.7 2.8-2.2 2.8-6.4 0.1-9.4 0.1-17.3 0.1-4.9 0-17.6 0-24.3 0-6.6 0-8-6.7-5.3-7.3 12.3-2.7 19.3-6.4 23.1-10 0.7-0.7 1.6-1 2.6-1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m177.1 303.9c-11.4 3.6-35.6 11.3-58.9 18.7-40.8-80.8-35-85.1-35-85.1 0 0 9.4-5.4 19.2-9.8q2.2-1.1 4.5-2c8.4-3.6 16.7-5.8 26.7-8.5q2-0.5 4-1c11.5-2.6 22.1-3.6 22.1-3.6 0.9 11.2 1.8 20.6 2.7 28.9 1.3 10.7 2.6 19.3 4.1 26.7 2.8 13.8 6.2 23.6 10.6 35.7z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m177.1 303.9c-11.4 3.6-35.6 11.3-58.9 18.7-40.8-80.8-35-85.1-35-85.1 0 0 9.4-5.4 19.2-9.8q2.2-1.1 4.5-2c8.4-3.6 16.7-5.8 26.7-8.5q2-0.5 4-1c11.5-2.6 22.1-3.6 22.1-3.6 0.9 11.2 1.8 20.6 2.7 28.9 1.3 10.7 2.6 19.3 4.1 26.7 2.8 13.8 6.2 23.6 10.6 35.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m166.5 268.2c-5.7-8.1-11.1-26.6-9.7-33.6l5.6 6.9c1.3 10.7 2.6 19.3 4.1 26.7z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m120.3 252.6c0 0 14.8-3.2 19.6 3.2 6.6-6.4 4.2-31.7 1.1-40.7-2.5 0.3-7.4 2.1-7.4 2.1l-10.5 16.3z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m120.3 252.6c0 0-10.1 2.2-11.1 10.4-14-10.4-13-25.7-9.9-34.7 2.3-1.4 7.6-2.6 7.6-2.6l10.5 11.6z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m123.7 200.2c1.9 7.3 5 14.6 9.9 17 0 0 4.7 13.3-13.3 35.4-18.9-13.4-13.4-26.9-13.4-26.9 8.8-5.3 6.3-12.4 2.6-18.5l5.2-8.4c2.3-3.7 7.9-2.8 9 1.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m123.7 200.2c-1.1-4.2-6.7-5.1-9-1.4l-1.7 2.7q0 0 0 0c0.1 1.8 0.2 3.2 0.2 4-0.2 5.2 7.1 4.9 13.1 2.4-1.1-2.4-1.9-5-2.6-7.7z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m87.5 180.1c5.2 14.2 7.1 20.3 16.6 25.5 14.3 7.9 30.6-1.6 29.7-17-0.7-13.9-9.1-34.8-24.9-36.3-15.7-1.6-26.6 13.6-21.4 27.8z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m125.1 159.6l-0.3 0.3q-0.6 0.7-1.8 1.8c-3.7 3.4-8.6 3.4-13 1.7-4 1.2-8 2.3-11.1 2.6 2.2 8 2 18.7-3.5 25.8-9.6 12.2-15.4-14-15.4-14l9.4-20.4c0 0 4.2-6.6 15.1-7.7 9.8-1.1 14.9 4.4 19.8 9.1 1.1-0.5 2-0.6 0.8 0.8zm-3 0.5c-2.8 0.5-6.5 1.7-10.4 2.8 5.6 1.3 9.2-1.2 10.4-2.8z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m88.2 194.5c1.6 2.7 4.3 4.4 6.8 5.1 3.7 0.9 5.5-2.5 4.4-6-1.1-3.1-4.2-7.4-8-6.8-3.6 0.6-5 4.6-3.2 7.7z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m118.2 322.6c0 0-2.1 120.8 13.7 164.4 15.2 41.8 60.6 113.8 60.6 113.8l26.3-0.7c0 0-41.8-91.1-48.6-127.1-11.4-59.7-8.9-164.1-8.9-164.1z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m141.8 332.9l7-20 12.5-4c0 0-1.1 47.5 1.6 96.7-11.3-21.8-21.1-61.8-21.1-72.7z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m188.8 602.1l32.4-0.8-1.8-10-35.5 1.7z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m131.1 318.7c0 0 41 93.8 67.5 147.1 21.4 43.2 88 101 88 101l18.2-12.7c0 0-50.1-68.5-64.9-97.7-47.3-93.6-35.6-132.1-62.8-152.5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m287.6 572.8l21.4-15.2-4.8-9.4-23.6 17.8z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m176.9 300.2l4.3 4.4c0.4 0.4 0 0.9-0.7 1.2l-61.8 19.5c-0.5 0.2-1 0.1-1.2-0.3l-2.2-5.1c-0.1-0.3 0.2-0.8 0.8-1l59.7-18.9c0.4-0.1 0.9 0 1.1 0.2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m171 309.4l1.6-0.5c0.3-0.1 0.5-0.4 0.4-0.5l-2.9-6.7c-0.1-0.2-0.4-0.2-0.7-0.1l-1.6 0.5c-0.4 0.1-0.6 0.3-0.5 0.5l3 6.6c0 0.2 0.4 0.3 0.7 0.2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m123.4 324.5l1.6-0.5c0.3-0.1 0.5-0.4 0.4-0.6l-2.9-6.6c-0.1-0.2-0.4-0.3-0.8-0.2l-1.6 0.5c-0.3 0.1-0.5 0.4-0.4 0.6l2.9 6.6c0.1 0.2 0.5 0.3 0.8 0.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m147.2 316.9l1.6-0.5c0.3-0.1 0.5-0.3 0.4-0.5l-2.9-6.6c-0.1-0.2-0.4-0.3-0.7-0.2l-1.6 0.5c-0.4 0.1-0.6 0.3-0.5 0.5l2.9 6.7c0.1 0.2 0.5 0.2 0.8 0.1z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m112.4 177c0.3 1.1 1.2 1.9 2 1.7 0.8-0.3 1.1-1.4 0.8-2.6-0.4-1.1-1.3-1.9-2.1-1.7-0.7 0.2-1.1 1.4-0.7 2.6z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m125.7 173c0.3 1.2 1.2 1.9 2 1.7 0.8-0.2 1.1-1.3 0.8-2.5-0.4-1.2-1.3-2-2.1-1.7-0.7 0.2-1.1 1.3-0.7 2.5z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m126.1 170.6l2.6-1.6c0 0-0.8 2.6-2.6 1.6z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m122.4 176.1c0 0 3.5 4.4 6.4 6.2-1.1 1.9-4 2.1-4 2.1z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m120.8 190.8c0.2-0.1 0.2-0.2 0.2-0.4-0.1-0.2-0.3-0.3-0.5-0.2-5.1 1.5-8.6-1.4-8.7-1.4-0.1-0.1-0.4-0.1-0.5 0-0.1 0.2-0.1 0.4 0.1 0.5 0.1 0.2 3.8 3.2 9.3 1.6q0.1-0.1 0.1-0.1z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m107.4 173.7q0.1-0.1 0.2-0.3c1.1-3 3.7-3.6 3.7-3.6 0.4-0.1 0.6-0.5 0.6-0.9-0.1-0.3-0.5-0.6-0.9-0.5-0.1 0-3.4 0.8-4.8 4.5-0.1 0.4 0.1 0.8 0.4 1 0.3 0 0.6 0 0.8-0.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m129.7 165.5q0.1-0.1 0.1-0.2c0-0.4-0.2-0.7-0.6-0.8-3.9-0.8-6.3 1.6-6.4 1.7-0.2 0.3-0.2 0.7 0.1 1 0.2 0.3 0.7 0.3 1 0 0.1-0.1 1.9-1.9 5-1.3 0.4 0.1 0.7-0.1 0.8-0.4z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m168.7 226.7c2.3 1.8 4.3 3.5 6.4 5.3q3.1 2.6 6.1 5.4 5.8 5.7 11.2 11.8 5.3 6.2 9.9 13.1c0.8 1.1 1.5 2.3 2.3 3.5q1.1 1.7 2.1 3.6c0.7 1.2 1.4 2.3 2.1 3.7l1 2.2 0.9 2.3c2.1 6 2.6 11.9 2.6 17.6-0.2 5.6-0.8 11.1-1.8 16.5-1.1 5.3-2.4 10.5-4 15.7-1.6 5.1-3.4 10.1-5.6 15.1l-7.2-2.7c1.2-4.8 2.4-9.9 3.3-14.8 0.9-5 1.7-10 2.1-15 0.4-4.9 0.6-9.8 0.3-14.6-0.1-2.3-0.4-4.6-0.8-6.8-0.5-2.2-1.1-4.3-1.8-6.2l-0.6-1.4-0.7-1.2c-0.6-1-1.3-2.1-1.9-3.1q-1-1.5-2-3c-0.8-1-1.4-2-2.2-2.9-2.9-4-6.2-7.7-9.5-11.4-3.3-3.7-6.9-7.2-10.5-10.6q-2.7-2.5-5.5-5c-1.9-1.6-3.9-3.3-5.6-4.7z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m196.8 335l-10.9 8 14.1 7.4c0 0 4.1-7.4 2.8-13.5z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m182.4 356l11.5 3.5 6.1-9.1-14.1-7.4z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m159.7 212.6c7.7-0.3 22.7 18.5 22.7 18.5l-15.6 22.1c0 0-17.6-14-18.9-23.7-1.2-8.3 2-16.5 11.8-16.9z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m159.7 212.6c7.7-0.3 22.7 18.5 22.7 18.5l-15.6 22.1c0 0-17.6-14-18.9-23.7-1.2-8.3 2-16.5 11.8-16.9z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g",
    d: "m296.3 588q-0.1 0-0.3 0-1-0.2-1.6-1.3c-0.2-0.5-0.1-0.9 0-1.2 1-1.7 6.5-2 7.1-2 0.2 0 0.3 0.1 0.4 0.2 0 0.2 0 0.3-0.1 0.4-1.3 1.5-3.6 3.9-5.5 3.9zm4.4-3.7c-2.2 0.2-5.1 0.7-5.6 1.6-0.1 0.1-0.2 0.2 0 0.5q0.4 0.8 1 0.8c1.1 0.2 2.7-0.9 4.6-2.9z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g",
    d: "m301.2 584.3c-1.9 0-5.5-1.1-6.2-2.5-0.1-0.3-0.2-0.9 0.4-1.6q0.7-0.5 1.6-0.5c2.1 0.3 4.7 3.8 4.8 4q0.1 0.1 0.1 0.3-0.1 0.2-0.3 0.2-0.2 0.1-0.4 0.1zm-4.5-3.8q-0.4 0-0.8 0.3c-0.3 0.3-0.3 0.5-0.2 0.7 0.4 0.9 3.3 1.9 5.1 2-0.9-1.1-2.6-2.9-3.9-3q-0.1 0-0.2 0z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "n",
    d: "m196.6 621.4c-1.4 0-2.7-0.2-3.6-0.9q-0.8-0.6-0.9-1.7c0-0.5 0.3-0.8 0.5-1 1.6-1.1 7.8 1.7 9 2.3 0.1 0 0.2 0.2 0.2 0.3 0 0.2-0.1 0.3-0.3 0.4-1.3 0.2-3.2 0.6-4.9 0.6zm-2.9-3.1q-0.5 0-0.7 0.1c-0.1 0.1-0.2 0.2-0.2 0.4q0.1 0.7 0.7 1.2c1 0.8 3.5 0.9 6.8 0.3-2.3-1-5.2-2-6.6-2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "n",
    d: "m201.4 620.8q0 0-0.1-0.1c-2-0.8-6.2-4.1-5.9-5.8 0-0.4 0.3-0.8 1.2-0.9 3.6-0.5 5.1 6 5.2 6.3q0 0.2-0.1 0.4-0.1 0.1-0.3 0.1zm-4.5-6.1q-0.1 0-0.2 0-0.6 0-0.6 0.3c-0.1 1 2.7 3.6 4.8 4.7-0.5-1.5-1.8-5-4-5z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m112.8 174.6l2.6-1.7c0 0-0.8 2.7-2.6 1.7z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m490.3 28.3h-290.7c-13.2 0-23.5 10.8-22.9 24l27.3 565.2c0.6 13.2 12 24 25.2 24h290.6c13.2 0 23.5-10.8 22.9-24l-27.3-565.2c-0.6-13.2-11.9-24-25.1-24z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m500.9 28.3h-290.6c-13.2 0-23.5 10.8-22.9 24l27.3 565.2c0.6 13.2 11.9 24 25.1 24h290.7c13.2 0 23.5-10.8 22.8-24l-27.2-565.2c-0.7-13.2-12-24-25.2-24z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m239 625.5c-4.3 0-8.1-3.7-8.3-8l-27.3-565.2c-0.2-4.3 3.3-8 7.6-8h290.7c4.3 0 8.2 3.7 8.4 8l27.2 565.2c0.2 4.3-3.3 8-7.6 8z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m238.9 621.5c-2.2 0-4.1-1.9-4.2-4l-27.3-565.2c-0.1-2.1 1.7-4 3.8-4h290.7c2.1 0 4.1 1.9 4.2 4l27.2 565.2c0.1 2.1-1.6 4-3.8 4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m326.6 588.9h-57.7c-3.2 0-6-2.6-6.1-5.9l-4.2-87.4c-0.1-1.6 0.4-3.1 1.5-4.2 1.1-1.1 2.5-1.7 4.1-1.7h57.7c3.2 0 6 2.6 6.1 5.8l4.3 87.5c0 1.5-0.5 3-1.6 4.2-1.1 1.1-2.5 1.7-4.1 1.7zm-62.4-97.2c-1 0-2 0.4-2.7 1.1-0.6 0.7-1 1.7-1 2.7l4.3 87.5c0.1 2.1 1.9 3.9 4.1 3.9h57.7c1 0 2-0.4 2.7-1.1 0.7-0.7 1-1.7 1-2.8l-4.3-87.4c-0.1-2.2-1.9-3.9-4.1-3.9z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m321.1 512h-54.2c-0.5 0-1-0.4-1-1 0-0.5 0.5-1 1-1h54.2c0.6 0 1 0.5 1 1 0 0.6-0.4 1-1 1z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m321.7 523.3h-54.2c-0.6 0-1-0.4-1-1 0-0.5 0.4-1 1-1h54.2c0.5 0 1 0.5 1 1 0 0.6-0.5 1-1 1z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m322.2 534.6h-54.2c-0.5 0-1-0.4-1-1 0-0.5 0.5-1 1-1h54.2c0.6 0 1 0.5 1 1 0 0.6-0.4 1-1 1z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m322.8 545.9h-54.2c-0.6 0-1-0.4-1-1 0-0.5 0.4-1 1-1h54.2c0.5 0 1 0.5 1 1 0 0.6-0.5 1-1 1z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m323.3 557.2h-54.2c-0.5 0-1-0.4-1-1 0-0.5 0.5-1 1-1h54.2c0.6 0 1 0.5 1 1 0 0.6-0.4 1-1 1z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m312.8 568.5h-43.1c-0.6 0-1-0.4-1-1 0-0.5 0.4-1 1-1h43.1c0.5 0 1 0.5 1 1 0 0.6-0.5 1-1 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f",
    d: "m362.9 268.3l-39.6 6.3q-3.3-7.6-5.9-10.6-2.5-2.9-8.2-5.9l1.4 31q33 8.7 44.4 18.3 15.1 13 16.1 32.9 0.5 11.7-4.2 21.4-4.7 9.8-12.5 16.3-7.8 6.6-16.7 9.5-9 3-22.1 3.5l0.2 5.5c0.2 4.3-3.1 7.8-7.4 7.8-4.3 0-8-3.5-8.2-7.8l-0.3-5.5q-15.8-1.4-25.8-5.1-9.9-3.7-17.4-10.2-7.4-6.5-11.6-14.1-4.3-7.5-6.7-18.3l43-5q2.5 10.6 6 15.3 3.4 4.7 11.1 8.4l-1.8-37.9q-21.9-6-31.2-10.4-9.3-4.4-16.4-14.1-7.1-9.7-7.7-23.6-1-19.1 11.8-31.9 12.7-12.8 39-14.2l-0.2-2.8c-0.2-4.3 3.1-7.8 7.5-7.8 4.3 0 8 3.5 8.2 7.8l0.1 2.8q24.1 1.5 37.2 11.4 13.2 9.8 17.9 27zm-69.4-10.7q-6.8 2.2-9.3 5.5-2.5 3.4-2.3 7.9 0.3 4.7 3.1 8.2 2.9 3.5 9.8 5.9zm20.7 105.5q9-2 13-6.7 4.1-4.7 3.8-10.5-0.3-5-4.1-9.3-3.7-4.2-14.3-7.9z"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m467.4 102.1h-197.9l19.3 400.2c1.6 33.8 30.3 61.1 64 61.1h197.9l-19.3-400.2c-1.6-33.7-30.3-61.1-64-61.1z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m515.9 102.1h-185.3-61.1c33.7 0 62.4 27.4 64 61.1l15.7 325.8c1.6 33.7 30.3 61.1 64 61.1h124.3c33.7 0 59.8-27.4 58.1-61.1l-15.7-325.8c-1.6-33.7-30.3-61.1-64-61.1z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m471.4 489c1.6 33.7-24.4 61.1-58.2 61.1h61.1 185.4c33.7 0 59.7-27.4 58.1-61.1z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m550.6 304.3h-174.2c-2.5 0-4.6-2-4.7-4.5-0.1-2.5 1.8-4.5 4.3-4.5h174.2c2.5 0 4.6 2 4.7 4.5 0.1 2.5-1.8 4.5-4.3 4.5z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m552 332.7h-174.2c-2.5 0-4.6-2.1-4.8-4.6-0.1-2.5 1.9-4.5 4.4-4.5h174.1c2.5 0 4.7 2 4.8 4.5 0.1 2.5-1.8 4.6-4.3 4.6z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m553.3 361h-174.1c-2.5 0-4.7-2-4.8-4.5-0.1-2.5 1.8-4.6 4.3-4.6h174.2c2.5 0 4.6 2.1 4.8 4.6 0.1 2.5-1.9 4.5-4.4 4.5z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m554.7 389.4h-174.2c-2.5 0-4.6-2.1-4.7-4.6-0.1-2.5 1.8-4.5 4.3-4.5h174.2c2.5 0 4.6 2 4.7 4.5 0.1 2.5-1.8 4.6-4.3 4.6z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m486.8 417.7h-104.9c-2.5 0-4.6-2-4.8-4.5-0.1-2.5 1.9-4.6 4.4-4.6h104.9c2.5 0 4.6 2.1 4.7 4.6 0.2 2.5-1.8 4.5-4.3 4.5z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m513.5 206.4c1.5 30.2-21.8 54.7-52.1 54.7-30.2 0-55.9-24.5-57.3-54.7-1.5-30.2 21.8-54.7 52.1-54.7 30.2 0 55.9 24.5 57.3 54.7z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m504 206.4c0.3 7.8-1.3 15.1-4.5 21.5-6.9 14.1-21.4 23.7-38.5 23.7-17.2 0-32.6-9.6-40.9-23.7-3.8-6.4-6.1-13.7-6.5-21.5-1.2-24.9 18.1-45.2 43-45.2 25 0 46.1 20.3 47.4 45.2z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m499.5 227.9c-6.9 14.1-21.4 23.7-38.5 23.7-17.2 0-32.6-9.6-40.9-23.7 11-7.6 24.5-12 39.2-12 14.6 0 28.5 4.4 40.2 12z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m478.2 191c0.5 11.1-8.1 20.1-19.2 20.1-11.1 0-20.5-9-21.1-20.1-0.5-11.2 8.1-20.2 19.2-20.2 11.1 0 20.5 9 21.1 20.2z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m626.5 626.5h-14.7l-1.4-34.1h14.7z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m610.4 592.5l0.7 17.5h14.7l-0.7-17.5z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m751.6 586.6l-14 4.6-17.6-30.1 14-4.6z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m734 556.5l-13.9 4.6 9 15.5 14-4.6z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m676.2 134.8c1.8 2.3 3.4 4.2 4.9 6.4q2.4 3.2 4.6 6.4 4.5 6.5 8.5 13.4c5.3 9.2 10.1 18.8 13.4 29.4l0.4 1 0.1 0.5 0.3 0.9 0.4 1.6 0.2 1.5c0.3 2 0.3 3.7 0.2 5.4-0.2 3.3-0.7 6.3-1.3 9.1-1.3 5.6-3.1 10.7-5 15.6-4 9.9-8.8 19-14.4 27.9l-9.9-4.8c3-9.3 5.9-18.9 8.2-28.3 1.2-4.6 2.1-9.3 2.6-13.7 0.2-2.1 0.3-4.2 0.2-5.9 0-0.9-0.1-1.7-0.3-2.2l-0.1-0.3q0-0.1-0.1-0.2v-0.1l-0.2-0.4-0.3-0.8-1.3-3.1-1.5-3.1c-1-2.1-2.1-4.2-3.2-6.3-2.3-4.1-4.8-8.2-7.3-12.3q-3.9-6-8.1-12c-2.7-4-5.7-8-8.4-11.6z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m679.5 246.8l-5.8 12.7h16.4c0 0 2.7-9.7-3.3-13.6z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m675.6 273.7l15.3-2.9-0.8-11.3h-16.4z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m603.4 70.4c0 1.2-0.6 2.1-1.4 2.1-0.7 0-1.4-0.9-1.4-2.1 0-1.2 0.7-2.2 1.4-2.2 0.8 0 1.4 1 1.4 2.2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m602.9 72.5c0 0-2.7 6.9-5.6 10.2 2.1 1.9 5.6 1 5.6 1z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m607.6 63.8q-0.2 0-0.4-0.1c-2.5-1.8-4.9-0.9-4.9-0.9-0.4 0.1-0.8-0.1-0.9-0.4-0.1-0.4 0-0.8 0.4-0.9 0.1-0.1 3.1-1.2 6.3 1.1 0.3 0.2 0.3 0.6 0.1 0.9-0.1 0.2-0.3 0.3-0.6 0.3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m641.7 84c-2.1 10.8-4.2 30.5 3.3 37.7 0 0-2.9 10.9-22.9 10.9-22 0-10.5-10.9-10.5-10.9 12-2.9 11.7-11.8 9.6-20.1z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m647.9 125.4c1.6-3.4 3.3-7.4-0.3-8.6-3.9-1.4-25.5-2.8-33-0.2-7.4 2.5-5.3 9.5-5.3 9.5z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "u",
    d: "m734.6 594.7c-1.1 1-2.3 1.8-3.2 1.7-0.4-0.1-0.9-0.3-1.2-1.2q-0.1-0.7 0.3-1.3c1.2-1.9 6-2.7 6.2-2.7 0.2 0 0.3 0 0.4 0.1 0.1 0.1 0.1 0.3 0 0.4-0.4 0.7-1.4 1.9-2.5 3zm-3.3-0.8q-0.1 0.2-0.2 0.3-0.3 0.4-0.2 0.8c0.2 0.6 0.5 0.7 0.6 0.7 1 0.2 3.2-1.9 4.5-3.7-1.4 0.3-3.7 1-4.7 1.9z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "u",
    d: "m737 591.8q0 0-0.1 0.1c-1.7 0.4-6 0.1-6.9-1.3-0.2-0.2-0.4-0.8 0.1-1.4q0.5-0.6 1.4-0.7c2.2-0.2 5.4 2.6 5.5 2.8q0.2 0.1 0.1 0.3 0 0.1-0.1 0.2zm-6.2-2.3q-0.1 0.1-0.1 0.1c-0.3 0.4-0.2 0.6-0.2 0.6 0.6 0.9 3.6 1.3 5.5 1.1-1-0.8-3-2.2-4.4-2.1q-0.5 0-0.8 0.3z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "u",
    d: "m605.9 627.2c-1.9 0-3.7-0.2-4.3-1.1-0.2-0.3-0.4-0.8 0-1.5q0.4-0.6 1.1-0.8c2.5-0.7 7.6 2.2 7.8 2.4 0.2 0 0.2 0.2 0.2 0.3 0 0.2-0.1 0.3-0.3 0.3-0.9 0.2-2.7 0.4-4.5 0.4zm-2.3-2.8q-0.4 0-0.7 0.1-0.5 0.1-0.7 0.4c-0.2 0.5-0.1 0.7 0 0.8 0.7 1 4.4 1 7.1 0.6-1.4-0.7-4-1.9-5.7-1.9z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "u",
    d: "m610.4 626.8q-0.1 0-0.2 0c-1.7-0.8-5.3-4-5-5.6 0.1-0.4 0.3-0.9 1.3-1q1.1-0.1 1.9 0.6c1.9 1.5 2.3 5.5 2.3 5.6q0 0.2-0.1 0.4-0.1 0-0.2 0zm-3.6-5.9q-0.1 0-0.2 0c-0.7 0-0.7 0.3-0.7 0.4-0.2 1 2.2 3.5 4 4.5-0.2-1.1-0.7-3.5-1.9-4.5q-0.6-0.4-1.2-0.4z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m736.4 589.5l11.9-11.4c0.5-0.4 1.1-0.5 1.6-0.1l11.2 7.4c1.1 0.8 1.2 2.4 0.2 3.4-4.2 3.9-6.5 5.6-11.7 10.6-3.3 3.1-12.9 13.6-17.4 17.9-4.3 4.1-9.2 0.4-7.8-1.8 6.5-9.6 10.5-18.8 10.9-23.7 0.1-0.8 0.5-1.7 1.1-2.3z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m611.9 624.8h16.1c0.6 0 1.1 0.4 1.2 1l2.9 13c0.3 1.4-0.7 2.7-2.1 2.6-5.8 0-14.1-0.4-21.4-0.4-8.5 0-15.9 0.5-25.8 0.5-6.1 0-7.7-6.1-5.2-6.7 11.5-2.5 20.9-2.8 30.8-8.9 1.1-0.6 2.3-1.1 3.5-1.1z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m591 155c-5.9 8.6-11.9 16.7-18.4 24.6-6.5 7.9-13.3 15.6-20.8 23l-2.9 2.7-0.7 0.7-0.5 0.5-0.8 0.6c-0.9 0.8-2 1.5-3 2-4 2.2-7.6 2.7-10.9 3.1-6.4 0.5-11.9-0.4-17.3-1.5-10.6-2.3-20.2-5.8-29.7-10.4l3.7-10.4c9.4 1.7 19.2 3.3 28.3 3.9 4.6 0.2 9.1 0.1 12.6-0.6 1.7-0.3 3-0.9 3.3-1.3 0.1 0 0.1-0.1 0.1-0.1q-0.1 0-0.1 0c0 0 0 0 0 0l0.2-0.2 0.6-0.6 2.3-2.6c6.3-7.1 12.3-14.7 18.2-22.5 5.9-7.7 11.8-15.7 17.4-23.5z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m671.3 125c13.8 3.1 29.6 40.7 29.6 40.7l-27.7 18.9c0 0-10.5-14.6-18.2-31-8.2-17.2 2.2-31.8 16.3-28.6z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m661.4 148.9l13.1 34.8-1.3 0.9c0 0-5.6-7.9-11.8-18.6z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m589 125.7c0 0-15.6 17.7-0.9 127 23.7 0 67.1 0 78.6 0 0.6-12-7-70.9 4.6-127.7 0 0-13.5-2.7-26.3-3.3-10-0.5-24.6-0.8-33.4 0-11.6 1-22.6 4-22.6 4z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m597.7 157.4c-0.2 0.3-2 18-15.5 33.6-0.3-7-0.4-13.4-0.4-19z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m604.5 137.7c1.9 13.9-25.5 49.4-25.5 49.4l-27.5-19c0 0 7.6-19.5 20.5-32.4 14.7-14.6 30.4-13.2 32.5 2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m491.6 190.9l-10.7-11.1-11.5 14.8c0 0 8.7 8.5 19.1 6.1z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m466.1 173.7l-5 15.5 8.3 5.4 11.5-14.8z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m643 67.9c-0.9 14.5-0.7 23.1-8.1 30.6-11 11.2-29 4.5-32.4-10-3.2-13.1-1.2-34.7 13.1-40.5 14-5.7 28.3 5.3 27.4 19.9z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m655.7 37.5c4.4 4.1 2.5 8.7 0.2 9.6 7.3 1.5 8.3 7.3 4.5 19.5-3.6 11.6-12.5 27.3-23.5 28.3-16.5 1.4-21.4-15.9-21.5-33-9.4 0.6-5.3-7.7-16.8-5.8-9.9 1.7-6.3-6.1-14.8-9.5-9.8-4-7.8-19.1 1.4-14.8 0 0-4.3 2.8 0.7 5.5 4.9 2.6 4.4-3.5 14.3-4.2 9.8-0.8 10.9 7.6 22.4 2.6 14.5-6.4 23.9-6.7 33.1 1.8z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m650.1 46.9c0 0 1.9-3.4 6.4-2.5 4.5 1 4.9 3 7.7 2.7 2.8-0.2 1.8 2.8 1.8 2.8 0 0-0.8-2.3-4.2-1-3.4 1.2-5.6-1.9-7-0.5-1.5 1.4-4.7-1.5-4.7-1.5z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m623.2 71.8c-0.6 3.8-2.7 7.2-5.1 9.3-3.6 3.1-6.6 0.6-6.8-3.7 0-3.9 1.7-10.3 5.8-11.8 4-1.5 6.9 1.9 6.1 6.2z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m616 252.7c0 0 16.7 112.3 25.8 154.4 10.1 46.1 79.7 168.4 79.7 168.4l25.6-8.3c0 0-55.5-110.3-61.2-155.9-6.2-49.5-19.2-158.6-19.2-158.6z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m714.4 567.4c-0.1 0 5.8 9 5.8 9l28.8-9.4-3.4-8.6z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m626.5 292.7c19.3 3.8 17.3 75.7 15 112.7-5.6-26.1-13.7-76.4-19.3-112.1 1.3-0.7 2.7-0.9 4.3-0.6z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m588.1 252.7c0 0-2 109.9-0.4 154.7 1.7 46.6 17.9 199.2 17.9 199.2h24.9c0 0 0.9-149.9 2.1-195.6 1.2-49.9 7.2-158.3 7.2-158.3z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m600.9 596.7c-0.2 0 1.4 10.3 1.4 10.3h30.2l0.9-9.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.63b30d14a2944f62df9936c317f7aa70.svg";
export { ForwardRef as ReactComponent };